import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_LOCATION_BY_HERO_REQUEST = 'Location/FETCH_LOCATION_BY_HERO_REQUEST'
const FETCH_LOCATION_BY_HERO_SUCCESS = 'Location/FETCH_LOCATION_BY_HERO_SUCCESS'
const FETCH_LOCATION_BY_HERO_FAILURE = 'Location/FETCH_LOCATION_BY_HERO_FAILURE'

const FETCH_LOCATION_BY_ID_REQUEST = 'Location/FETCH_LOCATION_BY_ID_REQUEST'
const FETCH_LOCATION_BY_ID_SUCCESS = 'Location/FETCH_LOCATION_BY_ID_SUCCESS'
const FETCH_LOCATION_BY_ID_FAILURE = 'Location/FETCH_LOCATION_ID_FAILURE'

const CREATE_LOCATION_REQUEST = 'Location/CREATE_LOCATION_REQUEST'
const CREATE_LOCATION_SUCCESS = 'Location/CREATE_LOCATION_SUCCESS'
const CREATE_LOCATION_FAILURE = 'Location/CREATE_LOCATION_FAILURE'

const UPDATE_LOCATION_REQUEST = 'Location/UPDATE_LOCATION_REQUEST'
const UPDATE_LOCATION_SUCCESS = 'Location/UPDATE_LOCATION_SUCCESS'
const UPDATE_LOCATION_FAILURE = 'Location/UPDATE_LOCATION_FAILURE'

const DELETE_LOCATION_REQUEST = 'Location/DELETE_LOCATION_REQUEST'
const DELETE_LOCATION_SUCCESS = 'Location/DELETE_LOCATION_SUCCESS'
const DELETE_LOCATION_FAILURE = 'Location/DELETE_LOCATION_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  locationList: [],
  locationObj: {}
}

// Default Reducer
const LOCATION = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCATION_BY_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_LOCATION_BY_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        locationList: action.payload
      }
    case FETCH_LOCATION_BY_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_LOCATION_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_LOCATION_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        locationObj: action.payload
      }
    case FETCH_LOCATION_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_LOCATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_LOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_LOCATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_LOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_LOCATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_LOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default LOCATION

// Action Creators
export const fetchLocationByHero = (heroId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_LOCATION_BY_HERO_REQUEST
      })

      const response = await API.get(EndPoints.LOCATION + `/hero/${heroId}`)
      dispatch({
        type: FETCH_LOCATION_BY_HERO_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_LOCATION_BY_HERO_FAILURE
      })
    }
  }
}

export const createLocation = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_LOCATION_REQUEST
      })

      await API.post(EndPoints.LOCATION, data)
      dispatch({
        type: CREATE_LOCATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_LOCATION_FAILURE
      })
    }
  }
}

export const updateLocation = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_LOCATION_REQUEST
      })

      await API.put(EndPoints.LOCATION, data)
      dispatch({
        type: UPDATE_LOCATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_LOCATION_FAILURE
      })
    }
  }
}

export const deleteLocation = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_LOCATION_REQUEST
      })

      await API.delete(EndPoints.LOCATION + `/${id}`)
      dispatch({
        type: DELETE_LOCATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_LOCATION_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/location.js